// extracted by mini-css-extract-plugin
export var audioPlayer = "_r3-0";